import React from 'react';
import Svg, { G, Path, Rect } from 'react-native-svg';

const EllipsisIcon = () => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <G fill="none" fillRule="evenodd" transform="translate(-8 -4)">
      <Rect width="32" height="24" fill="#F6F6F6" rx="4" />
      <Path
        fill="#00A651"
        d="M12 12c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm2 0c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm6 0c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2z"
      />
    </G>
  </Svg>
);

export default EllipsisIcon;
